<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label || 'Платники'"
    :items.sync="items"
    placeholder="Введіть iм'я платника"
    :total-items="totalItems"
    component-name="Payer"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as payersApi from "@/backend/payersApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Платники",
    },
    value: {
      type: Object,
    },
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      const { result, totalItems } = await payersApi.selectPayer(
        currentPage,
        perPage,
        search
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
